module.exports = __webpack_public_path__ + "ploni-aaa-400.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ploni-aaa-400.otf
// module id = 1198
// module chunks = 10